import { ITableColumn } from "components/interfaces";
import { useState } from "react";
import { CollapsibleRow } from "../../../UI/Table";
import { ActionCell, MaturityDateLink, MeasurementLink } from "./TableStickers";

interface IProps {
  row: any;
  columns: ITableColumn[];
  subColumns: ITableColumn[];
  blankColumns: number;
  onEdit: (rowId: string) => void;
  onDelete: (rowId: string) => void;
  onEditMaturityDate: (
    rowId: string,
    installmentId: number,
    newDate: Date
  ) => void;
}

const InstallmentRow = ({
  row,
  columns,
  subColumns,
  blankColumns,
  onEdit,
  onDelete,
  onEditMaturityDate,
}: IProps) => {
  const [open, setOpen] = useState(false);
  const dataId = row.id;

  const handleClickCollapse = () => setOpen(!open);

  const handleClickEdit = () => {
    onEdit(dataId);
  };

  const handleClickDelete = () => {
    onDelete(dataId);
  };

  const handleChangeDate = (installmentId) => (newDate) => {
    onEditMaturityDate(dataId, installmentId, newDate);
  };

  const subTableRows = row.installments.map((row) => {
    let newRow = { ...row };

    newRow.maturityDate = row.measurementId ? (
      row.maturityDate
    ) : (
      <MaturityDateLink
        id={row.id}
        date={row.maturityDate}
        onChange={handleChangeDate(row.id)}
      />
    );

    newRow.measurementLink = (
      <MeasurementLink
        id={row.measurementId}
        name={row.measurementName || ""}
      />
    );
    return newRow;
  });

  return (
    <CollapsibleRow
      open={open}
      columns={columns}
      subColumns={subColumns}
      row={row}
      rowDetails={subTableRows}
      actionCell={
        <ActionCell
          open={open}
          onClickCollapse={handleClickCollapse}
          onClickEdit={handleClickEdit}
          onClickDelete={handleClickDelete}
        />
      }
      subColumnLength={columns.length + 1}
      blankColumns={blankColumns}
    />
  );
};

export default InstallmentRow;
